import React from "react";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function LocalInformation() {
  UseScrollAnimation(); // ✅ just call it

  return (
    <div className="LocalInformationParent">
      <div className="LocalInformationBox">
        <div className="LocalInformationBoxHeading">
          <span className="LocalInformationBoxHeadingWord animate-top">
            Local Information
          </span>
          <span className="LocalInformationBoxHeadingLine animate-top"></span>
        </div>
        <div className="LocalInformationBoxContentBox">
          {/* <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLinePara">
              At Cornelius Woods, we take pride in our vibrant local community.
              With an array of local attractions, gourmet dining options, and
              recreational facilities, our residents are spoilt for choice.
              Here's a sneak peek into the treasures that surround us.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              Birkdale Village
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              A short drive from Cornelius Woods, Birkdale Village offers an
              immersive shopping experience with a delightful mix of retail
              shops, restaurants, and entertainment. From upscale boutiques to
              open-air concerts, there's something for everyone to enjoy.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              Antiquity
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Nestled in our neighborhood is Antiquity, an outdoor shopping
              center featuring local boutiques, gourmet restaurants, and a
              convenient grocery store. This vibrant retail hub provides a
              charming, small-town shopping experience, all within a leisurely
              stroll from Cornelius Woods.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              Jetton Park
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Unwind amidst nature at Jetton Park. With 104 acres of green
              space, the park offers lake views, walking trails, tennis courts,
              and picnic areas. It's the perfect spot for a peaceful afternoon
              or a family day out.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              CRAFTY BURG'R n' Tap
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              For those craving a hearty burger and a cold brew, CRAFTY BURG'R
              n' Tap offers an array of gourmet burgers and an impressive
              selection of beers on tap.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              Thigs Cocktail Bar
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Sip on exquisitely crafted cocktails at Thigs, an intimate and
              stylish local cocktail bar. It's the perfect spot for a nightcap
              or a weekend treat.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              BARREL & FORK
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Experience global flavors at BARREL & FORK, where they serve an
              eclectic menu in a cozy, upscale setting.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              The Harp and Crown
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              This traditional Irish pub offers an authentic Irish ambiance,
              hearty fare, and live music for a lively and enjoyable evening.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              D9 Brewing Lake Norman
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Enjoy a local craft beer at D9 Brewing, a popular local brewery
              known for its inventive and delicious brews.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              Hello, Sailor
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Offering stunning views of Lake Norman, Hello, Sailor serves up
              creative twists on classic American and seafood dishes.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              North Harbor Club
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Enjoy waterfront dining at its finest at North Harbor Club,
              serving an upscale menu in a stunning lakeside setting.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              131 MAIN
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              This local favorite offers a diverse menu with a focus on
              traditional Southern cuisine, prepared with fresh, local
              ingredients.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading">
              Spare Time Huntersville
            </div>
            <div className="LocalInformationBoxContentBoxLinePara">
              Round out the evening with a game at Spare Time, a modern
              entertainment venue featuring bowling, laser tag, and an arcade.
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLinePara">
              At Cornelius Woods, you're at the heart of it all. Explore the
              charming local community, indulge in culinary delights, and enjoy
              a vibrant lifestyle.
            </div>
          </div> */}
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Shopping
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              • Birkdale Village
              <br />• Antiquity{" "}
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Parks & Outdoor Recreation
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              • Jetton Park <br />• Lake Norman State Park <br />• Latta Nature
              Preserve <br />• Ramsey Creek Park <br />• Blythe Landing <br />•
              Bailey Road Park - <br />• Lake Norman Community Sailing <br />•
              Carolina Cruising Charters & Carolina Tiki <br />• Cornelius YMCA
              <br />• North Regional Recreation Center (Mecklenburg County)
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Dining & Local Favorites
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              • 131 MAIN Restaurant <br />• Harp and Crown LKN <br />• Barrel &
              Fork <br />• Seaboy <br />• The Serve <br />• LakeHouse Wine Bar &
              Grill <br />• Fin & Fino <br />• eeZ <br />• bar taco <br />•
              Buttermilk Sky Pie Shop <br />• Foxcroft Wine & Food <br />• Red
              Rocks Café <br />• North Italia <br />• Suffolk Punch Brewing
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Coffee & Quick Stops
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              • Starbucks <br />• Dunkin’ Donuts <br />• Waterbean Coffee <br />
              • Willow Wood Coffee <br />• Summit Coffee
            </div>
          </div>
          <div className="LocalInformationBoxContentBoxLine">
            <div className="LocalInformationBoxContentBoxLineHeading animate-top">
              Grocery & Daily Needs
            </div>
            <div className="LocalInformationBoxContentBoxLinePara animate-top">
              • Harris Teeter <br />• Publix <br />• Whole Foods <br />• Walmart
              Supercenter <br />• The Home Depot <br />• Ace Hardware
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocalInformation;
